import storage from "../Share/storageWithEncryption";

export default function saveTokenAfterRefresh(token: string, refreshToken: string, expirationTime: number) {
    storage.setDataToLocalStorage('token', token);
    storage.setDataToLocalStorage('refreshToken', refreshToken);
    storage.setDataToLocalStorage('expirationTime', expirationTime.toString());
}